import { legacy_createStore as createStore, combineReducers } from "redux";
import ConfigReducer from "../Reducer/Admin/ConfigReducer";


const reducers = combineReducers({
  config: ConfigReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "reset") {
    state = undefined;
  }
  return reducers(state, action);
};

const mainStore = createStore(rootReducer);

export default mainStore;
